import React, { useEffect, useRef, useState } from "react";

const RectClassModal = ({
  position,
  selectedClass, // This will now represent the text region data
  onClose,
  onSave,
}) => {
  const textareaRef = useRef(null);
  const [text, setText] = useState(selectedClass?.text || "");

  useEffect(() => {
    // Focus the textarea when modal opens
    if (textareaRef.current) {
      textareaRef.current.focus();
    }
  }, []);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && e.ctrlKey) {
      // Ctrl+Enter to save
      handleSave();
    } else if (e.key === 'Escape') {
      onClose();
    }
  };

  const handleSave = () => {
    onSave({ ...selectedClass, text }); // Pass back the updated region with text
  };

  return (
    <div
      className="fixed z-30 bg-white/10 backdrop-blur-sm p-6 rounded-2xl shadow-2xl border border-gray-200 w-[320px] transition-all duration-200 animate-fadeIn"
      style={{
        left: `${position.x + 20}px`,
        top: `${position.y + 20}px`,
      }}
      onKeyDown={handleKeyDown}
    >
      <h3 className="text-lg font-bold mb-4 text-gray-800 flex items-center gap-2">
        <svg xmlns='http://www.w3.org/2000/svg' className='h-5 w-5 text-blue-500' fill='none' viewBox='0 0 24 24' stroke='currentColor'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M8 17l4 4 4-4m0-5V3m-8 9v6a2 2 0 002 2h4a2 2 0 002-2v-6' /></svg>
        Enter Text
      </h3>
      <textarea
        ref={textareaRef}
        value={text}
        onChange={(e) => setText(e.target.value)}
        className="w-full border border-gray-300 px-4 py-2 rounded-lg mb-4 focus:outline-none focus:ring-2 focus:ring-blue-400 resize-none bg-gray-50 text-gray-700 placeholder-gray-400 transition-all duration-150 shadow-sm"
        rows={4}
        placeholder="Enter OCR text here..."
      />
      <div className="flex justify-end gap-2 mt-2">
        <button
          onClick={onClose}
          className="px-4 py-1.5 rounded-lg bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium shadow-sm transition-colors duration-150 border border-gray-200"
        >
          Cancel
        </button>
        <button
          onClick={handleSave}
          className="px-4 py-1.5 rounded-lg bg-gradient-to-r from-blue-500 to-blue-600 text-white font-semibold shadow-md hover:from-blue-600 hover:to-blue-700 transition-all duration-150 disabled:opacity-50 disabled:cursor-not-allowed"
          disabled={!text.trim()}
        >
          Save
        </button>
      </div>
    </div>
  );
};

export default RectClassModal;